import React from 'react'
import './SecondBtn.css'

const SecondBtn = () => {
    return (
        <button id='SecondBtn'>+</button>

    )
}

export default SecondBtn
